import { SocialShare } from '@fs/zion-icon'
import { Button, useOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ShareReservationsDialog from './ShareReservationsDialog'

export default function ShareReservationsButton({ refetchReservations }) {
  const overlay = useOverlay()
  const { t } = useTranslation()

  return (
    <>
      <Button Icon={SocialShare} emphasis="high" onClick={overlay.handleClick}>
        {t('group.reservations.buttons.share', 'Share')}
      </Button>
      <ShareReservationsDialog refetchReservations={refetchReservations} {...overlay} />
    </>
  )
}
